"use client";

import React from "react";

const techItems = [
  "React", "Next.js", "TypeScript", "Node.js", "PHP", "MySQL", 
  "PostgreSQL", "Supabase", "Tailwind CSS", "Framer Motion", 
  "Vite", "Prisma", "Docker", "Vercel", "Figma", "Git"
];

export function TechMarquee() {
  return (
    <div className="relative w-full overflow-hidden bg-neutral-900/20 py-10 border-y border-neutral-800/50">
      <div className="flex animate-marquee whitespace-nowrap">
        {[...techItems, ...techItems].map((item, index) => (
          <div 
            key={index} 
            className="mx-12 text-4xl md:text-6xl font-black uppercase tracking-tighter italic text-neutral-800 hover:text-violet-500/50 transition-colors cursor-default"
          >
            {item}
          </div>
        ))}
      </div>
      
      {/* Gradient Overlays */}
      <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-black to-transparent z-10" />
      <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-black to-transparent z-10" />
    </div>
  );
}